<template>
  <Dialog
    :model-value="visible"
    title="Validation Needed"
    dialog-type="error"
    dialog-size="small"
    :close-on-overlay="false"
    @update:model-value="(v) => { if (!v) closeDialog() }"
    @close="closeDialog"
  >
    <p class="validation-message">
      Workflow <strong>{{ workflowName }}</strong> is not validated. Only a validated workflow can be converted into a program.
    </p>

    <template #footer>
      <ResponsiveButton button_type="filled" built_in_theme="error" size="medium" @click="handleValidate">Ok, validate Workflow.</ResponsiveButton>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'WorkflowValidationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workflowName: {
      type: String,
      default: 'Customized Workflow 1'
    }
  },
  emits: ['close', 'validate'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    handleValidate() {
      this.$emit('validate');
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
.validation-message {
  font-size: 16px;
  line-height: 28px;
  color: #374957;
  margin: 0;
}
</style>
